/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Form_InvalidInputs */

const vi_shop_group_form_invalid = /** @type {(inputs: Shop_Group_Form_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn ô chưa hợp lệ — đã chuyển tới ô đầu tiên cần sửa.`)
};

/**

* @param {Shop_Group_Form_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_form_invalid = /** @type {((inputs?: Shop_Group_Form_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Form_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_form_invalid(inputs)
});